import { Injectable } from '@angular/core';

import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import { SecurityService } from '@bayclubs/utils';
import { GroupClassesPrivileges, ClubModel } from '@bayclubs/group-classes-employee-api';

@Injectable()
export class GroupClassesSecurityService {
    constructor(private securityService: SecurityService) {}

    public get canUseGroupClassesApplication() {
        return this.securityService.hasPrivilege('GroupClasses', 'canViewClasses');
    }

    public get canUseRecordedClassGroup() {
        return forkJoin([this.canUseRecordedClass, this.canUsePlaylists]).pipe(map(result => (result[0] || result[1])));
    }

    public get canUseRecordedClass() {
        return this.securityService.hasPrivilege('GroupClasses', 'canViewRecordedClass');
    }

    public get canUsePlaylists() {
        return this.securityService.hasPrivilege('GroupClasses', 'canViewPlaylists');
    }

    public get canUseGroupClassesReports() {
        return this.securityService.hasPrivilege('GroupClasses', 'canViewReports');
    }

    public get canUseClubs() {
        return this.securityService.hasPrivilege('GroupClasses', 'canViewClubs');
    }

    public filterClubsForViewClasses(clubs: ClubModel[]): Observable<ClubModel[]> {
        return this.securityService.getPrivilegesSnapshot$().pipe(
            map(snapshot => {
                const privileges = <GroupClassesPrivileges>snapshot.getPrivileges('GroupClasses');
                return clubs.filter(c => privileges.canViewClasses.indexOf(c.id) >= 0);
            })
        );
    }

    public filterClubsForReports(clubs: ClubModel[]): Observable<ClubModel[]> {
        return this.securityService.getPrivilegesSnapshot$().pipe(
            map(snapshot => {
                const privileges = <GroupClassesPrivileges>snapshot.getPrivileges('GroupClasses');
                return clubs.filter(c => privileges.canViewReports.indexOf(c.id) >= 0);
            })
        );
    }

    public filterClubsForManageClasses(clubs: ClubModel[]): Observable<ClubModel[]> {
        return this.securityService.getPrivilegesSnapshot$().pipe(
            map(snapshot => {
                const privileges = <GroupClassesPrivileges>snapshot.getPrivileges('GroupClasses');
                return clubs.filter(c => privileges.canManageClasses.indexOf(c.id) >= 0);
            })
        );
    }

    public canManageGroupClasses(clubId: string): Observable<boolean> {
        return this.securityService.hasPrivilege('GroupClasses', 'canManageClasses', clubId);
    }

}
